<div class="ks-p-5">
  <div class="warning-badge-void" style="padding-top: 12px; justify-self: center">
    <span inlineSVG="assets/icons/Error.svg" class="ks-text-danger ks-m-4"></span>
  </div>
  <p class="ks-font-weight-medium ks-font-size-sm ks-text-center ks-mb-3">Void transaction?</p>
  <p class="ks-text-neutral ks-font-weight-medium ks-font-size-sm ks-text-center ks-mb-3">
    This action cannot be undone and will mark the transaction as void.
  </p>
  <div class="ks-w-100 ks-mb-4">
    <kt-input
      [isTextarea]="true"
      [label]="'Reason for voiding'"
      [control]="getFormControl('reason')"
      [errors]="[{ validation: 'required', message: 'Please add a reason for your void' }]"
    ></kt-input>
  </div>

  <div class="d-flex justify-content-center">
    <button class="ks-btn-sm ks-btn-outline-neutral ks-mr-2" (click)="onCancel()">Cancel</button>
    <button class="ks-btn-sm ks-btn-danger" (click)="onConfirm()">Void transaction</button>
  </div>
</div>
